export default __webpack_public_path__ + "static/media/SourceSansPro-Light.fd3ce6c4.ttf";